import { motion } from "framer-motion";
import { DashboardSidebar } from "@/components/dashboard/DashboardSidebar";
import { HealthGauge } from "@/components/dashboard/HealthGauge";
import { CompetitorTable } from "@/components/dashboard/CompetitorTable";
import { ActivityLog } from "@/components/dashboard/ActivityLog";
import { CompetitorAnalysis } from "@/components/dashboard/CompetitorAnalysis";
import { Globe, TrendingUp, FileText, Zap } from "lucide-react";

const stats = [
  { label: "Pagini Optimizate", value: "342", icon: FileText, change: "+28" },
  { label: "Trafic Organic", value: "+47%", icon: TrendingUp, change: "vs. luna trecută" },
  { label: "Citări AI", value: "23", icon: Zap, change: "+12 săptămâna asta" },
  { label: "Site-uri Active", value: "3", icon: Globe, change: "din 5 disponibile" },
];

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-muted/30">
      <DashboardSidebar />
      
      <main className="ml-64 p-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-2xl font-bold text-foreground mb-1">
            Bine ai venit înapoi! 👋
          </h1>
          <p className="text-muted-foreground">
            Iată ce s-a întâmplat cu site-urile tale în ultimele 24 de ore.
          </p>
        </motion.div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * index }}
              className="card-elevated p-6"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                  <stat.icon className="w-5 h-5 text-primary" />
                </div>
              </div>
              <p className="text-2xl font-bold text-foreground mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
              <p className="text-xs text-primary mt-2">{stat.change}</p>
            </motion.div>
          ))}
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {/* Health Gauge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2 }}
            className="card-elevated p-8 flex flex-col items-center"
          >
            <h2 className="text-lg font-semibold text-foreground mb-6">
              Scor de Sănătate
            </h2>
            <HealthGauge score={72} size={200} />
            <p className="text-sm text-muted-foreground mt-6 text-center">
              Site-ul tău principal performează bine. 3 oportunități de
              îmbunătățire detectate.
            </p>
          </motion.div>

          {/* Competitor Table */}
          <div className="lg:col-span-2">
            <CompetitorTable />
          </div>
        </div>

        {/* Bottom Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Activity Log */}
          <ActivityLog />

          {/* Competitor Analysis */}
          <CompetitorAnalysis />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
